import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { QuoteMarkAsDeclinedPage } from 'src/app/modals/quote-mark-as-declined/quote-mark-as-declined.page';

const routes: Routes = [
    {
        path: '',
        component: QuoteMarkAsDeclinedPage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        FontAwesomeModule,
        RouterModule.forChild(routes)
    ],
    declarations: [QuoteMarkAsDeclinedPage]
})

export class QuoteMarkAsDeclinedPageModule { }
